<app-layout>
    <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.stakings')">Staking</inertia-link>
        - {{ subTitle }}
    </h1>
    <div class="bg-white rounded shadow overflow-hidden w-full">
        <form @submit.prevent="submit">
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                <div class="pr-6 pb-8 w-full">
                    <div class="font-weight-bold text-xl border-b mb-2 pb-4 font-medium">Staking Information</div>
                </div>

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label d-block">Currency:</label>
                    <t-rich-select
                        :options="currencies"
                        v-model="form.currency_id"
                        placeholder="Select currency"
                        value-attribute="id"
                        text-attribute="name"
                    >
                        <template
                            slot="label"
                            slot-scope="{ className, option, query }"
                        >
                            <div class="flex">
                                <div class="flex flex-col">
                                    <span>{{ option.text }}</span>
                                </div>
                            </div>
                        </template>
                    </t-rich-select>
                    <div v-if="errors.currency_id" class="form-error text-red-400">{{ errors.currency_id }}</div>
                </div>

                <div class="pr-6 pb-8 w-full lg:w-1/2">
                    <label class="form-label d-block">Status:</label>
                    <t-rich-select
                        v-model="form.status"
                        :options="[
                            {'id':'active','name':'Active'},
                            {'id':'sold','name':'Sold Out'},
                            {'id':'hidden','name':'Hidden'}
                        ]"
                        placeholder="Select status"
                        value-attribute="id"
                        text-attribute="name"
                    >
                        <template
                            slot="label"
                            slot-scope="{ className, option, query }"
                        >
                            <div class="flex">
                                <div class="flex flex-col">
                                    <span>{{ option.text }}</span>
                                </div>
                            </div>
                        </template>
                    </t-rich-select>
                    <div v-if="errors.status" class="form-error text-red-400">{{ errors.status }}</div>
                </div>

                <text-input v-model="form.min_amount" :error="errors.min_amount" class="pr-6 pb-8 w-full lg:w-1/2" label="Min Staking Amount" />

                <text-input v-model="form.max_amount" :error="errors.max_amount" class="pr-6 pb-8 w-full lg:w-1/2" label="Max Staking Amount" />

                <text-input v-model="form.allowed_days" :error="errors.allowed_days" class="pr-6 pb-8 w-full lg:w-1/2" label="Allowed days (separated by comma, e.g 30,60,90)" />

                <text-input v-model="form.rewards_percentage" :error="errors.rewards_percentage" class="pr-6 pb-8 w-full lg:w-1/2" label="Allowed percentage (separated by comma, e.g. 0.5,10,12.5)" />

            </div>
            <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
                <button v-if="isEdit" class="focus:outline-none text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Staking</button>
                <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">{{ actionButtonTitle }}</loading-button>
            </div>
        </form>
    </div>
</app-layout>
